import axiosInstance, { endpoints } from '@/lib/axios';
import type { QuizSummaryItem } from '@/lib/quiz-config';

// ----------------------------------------------------------------------

/** Payload sent to POST /api/v1/quiz when a prospect completes the quiz. */
export interface QuizSubmissionPayload {
  first_name: string;
  last_name: string;
  email: string;
  phone: string;
  /** Where the lead came from (defaults server-side to the quiz). */
  source?: string;
  /** Domain of interest, mapped onto the lead's formation theme. */
  formation_theme?: string;
  /** Ordered, human-readable question/answer pairs. */
  answers: QuizSummaryItem[];
}

/**
 * Submits a completed orientation quiz. Creates (or refreshes) the lead,
 * stores the answers and triggers the admin + confirmation e-mails.
 */
export async function submitQuiz(payload: QuizSubmissionPayload): Promise<void> {
  await axiosInstance.post(endpoints.quiz.submit, payload);
}
